import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'production'
        ? 'https://api.shivambuildcare.com'
        : 'http://localhost:8081');

const api = axios.create({ baseURL });

// Session keys rotate on every API response. Parallel requests with the same
// key cause "Invalid session key" errors, so queue requests one at a time.
let tail = Promise.resolve();

api.interceptors.request.use(
    config => {
        const previous = tail;
        let release;
        tail = new Promise(resolve => {
            release = resolve;
        });
        config.__releaseSessionQueue = release;

        return previous.then(() => {
            const sessionKey = localStorage.getItem('x-session-key');
            if (sessionKey) {
                config.headers['x-session-key'] = sessionKey;
            }
            return config;
        });
    },
    error => Promise.reject(error)
);

function readSessionKey(headers = {}) {
    return headers['x-session-key'] || headers['X-Session-Key'] || null;
}

api.interceptors.response.use(
    response => {
        const newSessionKey = readSessionKey(response.headers);
        if (newSessionKey) {
            localStorage.setItem('x-session-key', newSessionKey);
        }
        if (response.config.__releaseSessionQueue) {
            response.config.__releaseSessionQueue();
        }
        return response;
    },
    error => {
        const newSessionKey = readSessionKey(error.response?.headers);
        if (newSessionKey) {
            localStorage.setItem('x-session-key', newSessionKey);
        }
        if (error.config?.__releaseSessionQueue) {
            error.config.__releaseSessionQueue();
        }

        if (error.response?.status === 401) {
            localStorage.removeItem('x-session-key');
            localStorage.removeItem('isLoggedIn');
            window.location.assign('/login');
        }
        return Promise.reject(error);
    }
);

export default api;
